/* eslint-disable no-use-before-define */

import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { imgBook2 } from '../../../../utils/constants';
import clsx from 'clsx';
import { TitleNbr, Page, Paragrapth, TitlePage } from '@orientaction/components';
import { useMemo, useState } from 'react';
import useStyles from '../../style';
import { Link } from 'react-router-dom';
import { useLanguage } from '@orientaction/hooks';

const Page24 = (props: any) => {
  const classes = usesStyles();
  const classe = useStyles();
  const { language } = useLanguage();

  const image = useMemo(() => {
    return language === 'GB' ? 'en_NEEDSPRO.png' : 'NEEDSPRO.png';
  }, [language]);
  return (
    <Page id={24}>
      <TitlePage>
        PASSEZ MAINTENANT LE TEST <br />
        DES 7 BESOINS PROFESSIONNELS NEEDS PRO®
      </TitlePage>
      <div style={{ marginBottom: '20px' }}>
        <Grid container={true} spacing={2} justifyContent="center">
          <Grid item={true} xs={11}>
            <div className={classe.cardImageBtn}>
              <img
                src={`${imgBook2}/${image}`}
                alt="couverture intro"
                className={classe.imageBtn}
              />
              <Link
                to={language === 'GB' ? '/en/tests/needs-pro' : '/tests/needs-pro'}
                target="_blank"
                rel="noopener noreferrer"
                className={classe.btnInside}
                style={{ bottom: '12%' }}>
                Clique
              </Link>
            </div>
          </Grid>
        </Grid>
      </div>
    </Page>
  );
};

const usesStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 275,
      minHeight: '1150px',
      height: 'auto',
      padding: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    textCenterTop: {
      textAlign: 'center',
    },
    img: {
      width: '100%',
      height: 'auto',
    },
    trait: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      marginTop: '50px',
      marginBottom: '50px',
    },
    flexPosition: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    positionRelative: {
      position: 'relative',
    },
    positionAbsolute: {
      position: 'absolute',
    },
    opacity07: {
      opacity: 0.7,
    },
    logo: {
      width: '50%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    paragraphe: {
      fontSize: '15px',
      color: 'black',
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
    },
    paragraphe1: {
      fontSize: '12px',
      color: 'black',
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
    },
    positionCenter: {
      display: 'block',
      margin: 'auto',
    },
    cardBgGrey: {
      padding: 15,
      background: '#e8eef4',
    },
  })
);
export default Page24;
